import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CLIENTS_REQUEST } from "./types";

interface ClientState {
  allClients: any | null;
  clientDetails: any | null;
  clientAllUsers: any | null;
  tenantAllUsers: any | null;
  users: any | null;
  subDivisionList: any | null;
  subDivisionDetails: any | null;
  clientDocuments: any | null;
  processesProcedure: any | null;
  allForms: any[] | null;
  formDetails: any | null;
  formDocument: any | null;
  formDefinedNames: any | null;
  formSections: any | null;
  clientsList: any | null;
  formsList: any | null;
  rushFeesList: any | null;
  currentClientDetails: any | null;
  currentSubDivisionList: any | null;
  currentSubDivisionDetails: any | null;
  currentProcessesProcedure: any | null;
  loading: boolean;
  error: any | null;
}

const clientInitialState: ClientState = {
  allClients: null,
  clientDetails: null,
  clientAllUsers: null,
  tenantAllUsers: null,
  users: null,
  subDivisionList: null,
  subDivisionDetails: null,
  clientDocuments: null,
  processesProcedure: null,
  allForms: null,
  formDetails: null,
  formDocument: null,
  formDefinedNames: null,
  formSections: null,
  clientsList: null,
  formsList: null,
  rushFeesList: null,
  currentClientDetails: null,
  currentSubDivisionList: null,
  currentSubDivisionDetails: null,
  currentProcessesProcedure: null,
  loading: false,
  error: null,
};

export const clientSlice = createSlice({
  name: CLIENTS_REQUEST,
  initialState: clientInitialState,
  reducers: {
    getAllClientsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getAllClientsSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.allClients = action.payload.response;
    },
    getAllClientsFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getClientDetailsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getClientDetailsSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.clientDetails = action.payload.response;
    },
    getClientDetailsFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getClientAllUsersRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getClientAllUsersSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.clientAllUsers = action.payload.response;
    },
    getClientAllUsersFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getTenantAllUsersRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getTenantAllUsersSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.tenantAllUsers = action.payload.response;
    },
    getTenantAllUsersFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getClientUsersRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getClientUsersSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.users = action.payload.response;
    },
    getClientUsersFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getClientSubDivisionListRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getClientSubDivisionListSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.subDivisionList = action.payload.response;
    },
    getClientSubDivisionListFailure(
      state,
      action: PayloadAction<{ error: any }>
    ) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getSubdivisionDetailsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getSubdivisionDetailsSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.subDivisionDetails = action.payload.response;
    },
    getSubdivisionDetailsFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getClientDocumentsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getClientDocumentsSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.clientDocuments = action.payload.response;
    },
    getClientDocumentsFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getProcessesProcedureRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getProcessesProcedureSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.processesProcedure = action.payload.response;
    },
    getProcessesProcedureFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getFormsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getFormsSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.allForms = action.payload.response;
    },
    getFormsFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getFormDetailsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getFormDetailsSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.formDetails = action.payload.response;
    },
    getFormDetailsFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getFormDocumentRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getFormDocumentSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.formDocument = action.payload.response;
    },
    getFormDocumentFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getFormDefinedNamesRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getFormDefinedNamesSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.formDefinedNames = action.payload.response;
    },
    getFormDefinedNamesFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getClientFormSectionsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getClientFormSectionsSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.formSections = action.payload.response;
    },
    getClientFormSectionsFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getClientsListRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getClientsListSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.clientsList = action.payload.response;
    },
    getClientsListFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getFormListByClientIdRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getFormListByClientIdSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.formsList = action.payload.response;
    },
    getFormListByClientIdFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getRushFeesListRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getRushFeesListSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.rushFeesList = action.payload.response;
    },
    getRushFeesListFailure(state, action: PayloadAction<{ error: any }>) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getCurrentClientDetailsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getCurrentClientDetailsSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.currentClientDetails = action.payload.response;
    },
    getCurrentClientDetailsFailure(
      state,
      action: PayloadAction<{ error: any }>
    ) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getCurrentClientSubDivisionListRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getCurrentClientSubDivisionListSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.currentSubDivisionList = action.payload.response;
    },
    getCurrentClientSubDivisionListFailure(
      state,
      action: PayloadAction<{ error: any }>
    ) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getCurrentSubdivisionDetailsRequest(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    getCurrentSubdivisionDetailsSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.currentSubDivisionDetails = action.payload.response;
    },
    getCurrentSubdivisionDetailsFailure(
      state,
      action: PayloadAction<{ error: any }>
    ) {
      state.loading = false;
      state.error = action.payload.error;
    },
    getCurrentProcessesProcedureRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getCurrentProcessesProcedureSuccess(
      state,
      action: PayloadAction<{ response: any }>
    ) {
      state.loading = false;
      state.currentProcessesProcedure = action.payload.response;
    },
    getCurrentProcessesProcedureFailure(
      state,
      action: PayloadAction<{ error: any }>
    ) {
      state.loading = false;
      state.error = action.payload.error;
    },
    resetClientData(state) {
      state.clientAllUsers = null;
      state.subDivisionList = null;
      state.processesProcedure = null;
      state.formsList = null;
      state.formDetails = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  getAllClientsRequest,
  getAllClientsSuccess,
  getAllClientsFailure,
  getClientDetailsRequest,
  getClientDetailsSuccess,
  getClientDetailsFailure,
  getClientAllUsersRequest,
  getClientAllUsersSuccess,
  getClientAllUsersFailure,
  getTenantAllUsersRequest,
  getTenantAllUsersSuccess,
  getTenantAllUsersFailure,
  getClientUsersRequest,
  getClientUsersSuccess,
  getClientUsersFailure,
  getClientSubDivisionListRequest,
  getClientSubDivisionListSuccess,
  getClientSubDivisionListFailure,
  getSubdivisionDetailsRequest,
  getSubdivisionDetailsSuccess,
  getSubdivisionDetailsFailure,
  getClientDocumentsRequest,
  getClientDocumentsSuccess,
  getClientDocumentsFailure,
  getProcessesProcedureRequest,
  getProcessesProcedureSuccess,
  getProcessesProcedureFailure,
  getFormsRequest,
  getFormsSuccess,
  getFormsFailure,
  getFormDetailsRequest,
  getFormDetailsSuccess,
  getFormDetailsFailure,
  getFormDocumentRequest,
  getFormDocumentSuccess,
  getFormDocumentFailure,
  getFormDefinedNamesRequest,
  getFormDefinedNamesSuccess,
  getFormDefinedNamesFailure,
  getClientFormSectionsRequest,
  getClientFormSectionsSuccess,
  getClientFormSectionsFailure,
  getClientsListRequest,
  getClientsListSuccess,
  getClientsListFailure,
  getFormListByClientIdRequest,
  getFormListByClientIdSuccess,
  getFormListByClientIdFailure,
  getRushFeesListRequest,
  getRushFeesListSuccess,
  getRushFeesListFailure,
  getCurrentClientDetailsRequest,
  getCurrentClientDetailsSuccess,
  getCurrentClientDetailsFailure,
  getCurrentClientSubDivisionListRequest,
  getCurrentClientSubDivisionListSuccess,
  getCurrentClientSubDivisionListFailure,
  getCurrentSubdivisionDetailsRequest,
  getCurrentSubdivisionDetailsSuccess,
  getCurrentSubdivisionDetailsFailure,
  getCurrentProcessesProcedureRequest,
  getCurrentProcessesProcedureSuccess,
  getCurrentProcessesProcedureFailure,
  resetClientData,
} = clientSlice.actions;
export default clientSlice.reducer;
